import React, { useState } from 'react';
import { View, Text, TextInput, TouchableOpacity, StyleSheet } from 'react-native';
import {
  TagIcon,
  DragHandleIcon,
  DeleteIcon,
  ArrowUpIcon,
  ArrowDownIcon
} from './FencingIcons';

const DEFAULT_OPTIONS = ['maschi', 'femmine', 'junior', 'senior'];

// Dialog semplice custom (React Native base, può essere sostituito da una libreria modale se necessario)
function CustomDialog({ visible, onConfirm, onCancel }) {
  const [value, setValue] = React.useState('');
  if (!visible) return null;
  const handleAdd = () => {
    if (value.trim()) {
      onConfirm(value.trim());
      setValue('');
    }
  };
  return (
    <View style={dialogStyles.overlay}>
      <View style={dialogStyles.dialog}>
        <Text style={{ fontWeight: 'bold', fontSize: 16, marginBottom: 8 }}>Nuova categoria personalizzata</Text>
        <TextInput
          style={dialogStyles.input}
          value={value}
          onChangeText={setValue}
          placeholder="Nome categoria"
          autoFocus
          onSubmitEditing={handleAdd}
        />
        <View style={{ flexDirection: 'row', justifyContent: 'flex-end', marginTop: 14 }}>
          <TouchableOpacity onPress={() => { setValue(''); onCancel(); }} style={dialogStyles.btn}><Text style={{ color: '#d32f2f' }}>Annulla</Text></TouchableOpacity>
          <TouchableOpacity onPress={handleAdd} style={dialogStyles.btn}><Text style={{ color: '#1976d2', fontWeight: 'bold' }}>Aggiungi</Text></TouchableOpacity>
        </View>
      </View>
    </View>
  );
}


const dialogStyles = StyleSheet.create({
  overlay: {
    position: 'absolute', left: 0, top: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.25)', justifyContent: 'center', alignItems: 'center', zIndex: 9999
  },
  dialog: {
    width: 320, backgroundColor: '#fff', borderRadius: 12, padding: 18, elevation: 6
  },
  input: {
    borderWidth: 2, borderColor: '#b3c6e6', borderRadius: 8, padding: 8, backgroundColor: '#f4faff', fontWeight: 'bold', fontSize: 15, marginBottom: 8
  },
  btn: { marginLeft: 18 }
});

// Drag handle: puoi sostituirlo con un'icona migliore o una libreria DnD se vuoi
const DragHandle = () => <DragHandleIcon style={{ fontSize: 20, marginRight: 8, color: '#666' }} />;

export default function CategoryListManager({ categories, setCategories }) {
  const [dialogVisible, setDialogVisible] = useState(false);
  const [dropdown, setDropdown] = useState('');

  // Dropdown: "Altro" + tutte le default non già selezionate
  const availableDefaults = DEFAULT_OPTIONS.filter(opt => !categories.includes(opt));

  // Drag & drop semplificato (solo up/down)
  const moveCategory = (from, to) => {
    if (to < 0 || to >= categories.length) return;
    const updated = [...categories];
    const [moved] = updated.splice(from, 1);
    updated.splice(to, 0, moved);
    setCategories(updated);
  };

  const removeCategory = idx => {
    setCategories(categories.filter((_, i) => i !== idx));
  };

  // OnChange del menu a tendina
  const handleDropdown = (val) => {
    setDropdown('');
    if (!val || val === '') return;
    if (val === 'altro') {
      setDialogVisible(true);
    } else if (!categories.includes(val)) {
      setCategories([...categories, val]);
    }
  };

  // Conferma dal dialog custom
  // Dopo la conferma, il dialog si chiude e il campo si resetta
  const handleCustomConfirm = (customCat) => {
    if (customCat && !categories.includes(customCat)) {
      setCategories([...categories, customCat]);
    }
    setDialogVisible(false);
  };

  return (
    <View style={styles.card}>
      <View style={styles.titleRow}>
        <TagIcon style={{ fontSize: 24, color: '#1976d2', marginRight: 10 }} />
        <Text style={styles.title}>Categorie partecipanti</Text>
      </View>
      {/* Dropdown per selezione categoria di default + Altro */}
      <View style={styles.addRow}>
        <View style={styles.dropdownWrap}>
          <select
            style={styles.dropdown}
            value={dropdown}
            onChange={e => handleDropdown(e.target.value)}
          >
            <option value="">Scegli categoria...</option>
            <option value="altro">Altro...</option>
            {availableDefaults.map(opt => (
              <option key={opt} value={opt}>{opt.charAt(0).toUpperCase() + opt.slice(1)}</option>
            ))}
          </select>
        </View>
      </View>
      {/* Lista categorie selezionate */}
      {categories.map((cat, idx) => (
        <View key={cat} style={styles.catRow}>
          <TouchableOpacity onPress={() => moveCategory(idx, idx - 1)} disabled={idx === 0} style={{ opacity: idx === 0 ? 0.3 : 1 }}>
            <ArrowUpIcon style={{ fontSize: 22, color: '#1976d2' }} />
          </TouchableOpacity>
          <TouchableOpacity onPress={() => moveCategory(idx, idx + 1)} disabled={idx === categories.length - 1} style={{ opacity: idx === categories.length - 1 ? 0.3 : 1 }}>
            <ArrowDownIcon style={{ fontSize: 22, color: '#1976d2' }} />
          </TouchableOpacity>
          <DragHandle />
          <Text style={styles.catText}>{cat}</Text>
          <TouchableOpacity onPress={() => removeCategory(idx)}>
            <DeleteIcon style={{ fontSize: 20, color: '#d32f2f', marginLeft: 6 }} />
          </TouchableOpacity>
        </View>
      ))}
      {/* Dialog custom per "Altro" */}
      <CustomDialog
        visible={dialogVisible}
        onConfirm={handleCustomConfirm}
        onCancel={() => setDialogVisible(false)}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  titleRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 10
  },
  card: {
    backgroundColor: '#fff',
    borderRadius: 18,
    boxShadow: '0 4px 24px #0002',
    padding: 16,
    marginVertical: 12,
    borderWidth: 2,
    borderColor: '#1976d2',
    transition: 'box-shadow 0.2s',
    maxWidth: '100vw',
    overflowX: 'auto',
  },
  title: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#1976d2',
    marginBottom: 10,
  },
  catRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 7,
    gap: 4
  },
  catText: {
    fontSize: 16,
    fontWeight: 'bold',
    marginRight: 8,
    color: '#333',
    flex: 1
  },
  removeBtn: {
    color: '#d32f2f',
    fontWeight: 'bold',
    fontSize: 18,
    marginLeft: 6
  },
  arrowBtn: {
    fontSize: 17,
    marginHorizontal: 2,
    color: '#1976d2',
    fontWeight: 'bold',
    opacity: 0.7
  },
  addRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 12
  },
  input: {
    borderWidth: 2,
    borderColor: '#b3c6e6',
    borderRadius: 8,
    padding: 8,
    backgroundColor: '#f4faff',
    fontWeight: 'bold',
    fontSize: 15,
    flex: 1,
    marginRight: 8
  },
  addBtn: {
    backgroundColor: '#e3f2fd',
    borderRadius: 8,
    paddingVertical: 7,
    paddingHorizontal: 12,
    alignSelf: 'flex-start',
  },
  dropdownWrap: {
    flex: 1,
    marginRight: 8
  },
  dropdown: {
    width: '100%',
    padding: 8,
    borderRadius: 8,
    border: '2px solid #b3c6e6',
    backgroundColor: '#f4faff',
    fontWeight: 'bold',
    fontSize: 15,
  }
});
